const locale = {
  xAxisTimeFormat: {
    year: '{yyyy}年',
    month: '{M}月{d}日',
    day: '{M}月{d}日'
  }
};
export default locale;